// Action types for fetching orders
export const FETCH_PRODUCTS_REQUEST = 'FETCH_PRODUCTS_REQUEST';
export const FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
export const FETCH_PRODUCTS_FAILURE = 'FETCH_PRODUCTS_FAILURE';
// Action types for fetching products
export const FETCH_UPDATE_PRODUCTS_REQUEST = 'FETCH_UPDATE_PRODUCTS_REQUEST';
export const FETCH_UPDATE_PRODUCTS_SUCCESS = 'FETCH_UPDATE_PRODUCTS_SUCCESS';
export const FETCH_UPDATE_PRODUCTS_FAILURE = 'FETCH_UPDATE_PRODUCTS_FAILURE';
// Fetch data actions
export const fetchProductsRequest = (payload) => ({
    type: FETCH_PRODUCTS_REQUEST,
    payload,
});
export const fetchProductsSuccess = (payload) => ({
    type: FETCH_PRODUCTS_SUCCESS,
    payload,
});
export const fetchProductsFailure = (error) => ({
    type: FETCH_PRODUCTS_FAILURE,
    payload: error,
});
// Save data actions
export const updateProductsRequest = (payload) => ({
    type: FETCH_UPDATE_PRODUCTS_REQUEST,
    payload,
});
export const updateProductsSuccess = (payload) => ({
    type: FETCH_UPDATE_PRODUCTS_SUCCESS,
    payload,
});
export const updateProductsFailure = (error) => ({
    type: FETCH_UPDATE_PRODUCTS_FAILURE,
    payload: error,
});
